<template>
  <g
    :transform="(flip === true ? `scale(-.8 .8) translate(-${x/.8 + 3} ${y/.8 + 15}) rotate(-90)` : `scale(.8 .8) translate(${x + 3} ${y/.8 + 15}) rotate(-90)`)"
    stroke="white"
  >
    <rect x="0" y="0" width="25" height="76" fill="white"/>
    <path fill="#e0e0e0" d="M15.5.5a4,4,0,0,0-4,4v10h8V4.5A4,4,0,0,0,15.5.5Z"/>
    <path :fill="color" d="M25,30.5v-14a2.0059,2.0059,0,0,0-2-2H8a2.0059,2.0059,0,0,0-2,2v14Z"/>
    <rect :fill="color" x="3" y="30.5" width="25" height="3"/>
    <rect :fill="color" x="5.5" y="75.5" width="20" height="3"/>
    <rect :fill="color" x="0.5" y="33.5" width="30" height="42" rx="2"/>
    <rect :fill="color" x="0.5" y="33.5" width="30" height="42" rx="2"/>
    <rect :fill="color" x="0.5" y="49.5" width="30" height="22"/>
    <line :fill="color" x1="27.5" y1="49.5" x2="27.5" y2="71.5"/>
    <line :fill="color" x1="23.5" y1="49.5" x2="23.5" y2="71.5"/>
    <line :fill="color" x1="19.5" y1="49.5" x2="19.5" y2="71.5"/>
    <line :fill="color" x1="15.5" y1="49.5" x2="15.5" y2="71.5"/>
    <line :fill="color" x1="11.5" y1="49.5" x2="11.5" y2="71.5"/>
    <line :fill="color" x1="7.5" y1="49.5" x2="7.5" y2="71.5"/>
    <line :fill="color" x1="3.5" y1="49.5" x2="3.5" y2="71.5"/>
  </g>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    plugColor: String,
    x: Number,
    y: Number,
    flip: Boolean
  },
  data() {
    return {
      plugWidth: 30,
      plugHeight: 10
    };
  },
  computed: {
    ...mapGetters([
      'getCssColor'
    ]),
    color () {
      return this.getColor(this.plugColor);
    },
    yRecalculated () {
      return this.y - this.plugHeight / 2;
    }
  },
  methods: {
    getColor (colorName) { return this.getCssColor(colorName)},
    getNoseColor (colorName) { return this.getCssColor(colorName + "Nase")}
  }
}
</script>